import {Component, Input} from '@angular/core';
import {SelectionTag, TagStatus} from '../models/selection-tag';

@Component({
    selector: 'app-tag-list',
    templateUrl: './tag-list.component.html',
    styleUrls: ['./tag-list.component.scss'],
    standalone: false
})
export class TagListComponent {
    @Input() tags: SelectionTag[];
    @Input() status: TagStatus;
    @Input() block = false;
    @Input() center = false;

    constructor() {
    }

}
